import { t } from './copy';

interface CodedError {
  code?: string;
  message?: string;
  details?: unknown;
}

/** Map Firebase/Functions errors to calm, user-facing copy. */
export function messageForError(err: unknown): string {
  const e = (err ?? {}) as CodedError;
  const code = e.code ?? '';
  const details = e.details as { reason?: string } | undefined;

  if (details?.reason === 'not-pending') return t('admin.notPending');
  switch (code) {
    case 'auth/email-already-in-use':
      return t('auth.signup.emailInUse');
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
    case 'auth/invalid-email':
      return t('auth.login.error');
    case 'auth/too-many-requests':
      return t('auth.login.tooMany');
    case 'auth/network-request-failed':
    case 'unavailable':
    case 'functions/unavailable':
      return t('net.offline');
    case 'permission-denied':
    case 'functions/permission-denied':
    case 'storage/unauthorized':
      return t('error.permission');
    case 'functions/already-exists':
    case 'functions/failed-precondition':
    case 'functions/not-found':
    case 'functions/invalid-argument':
      // Server messages for these codes are written in the same calm tone. The SDK may
      // append an HTTP status like " [409]", which users shouldn't see.
      return e.message?.replace(/\s*\[\d{3}\]$/, '') || t('error.generic');
    default:
      return t('error.generic');
  }
}
